// extracted by mini-css-extract-plugin
export default {"passwordLinkExpiredPage":"PasswordLinkExpiredPage_passwordLinkExpiredPage__mQqs-","genericActionBlock":"PasswordLinkExpiredPage_genericActionBlock__0XudM"};